import React, { useState } from 'react';
import { dbHelpers, supabase } from '../lib/supabase';

const DashboardDebug = ({ user }) => {
  const [testResults, setTestResults] = useState({});
  const [loading, setLoading] = useState(false);

  const runTests = async () => {
    setLoading(true);
    const results = {};

    try {
      // Test 1: Basic Supabase connection
      console.log('Testing basic Supabase connection...');
      const { error: sessionError } = await supabase.auth.getSession();
      results.session = sessionError ? `Error: ${sessionError.message}` : 'Success';

      // Test 2: Test leads query
      console.log('Testing leads query...');
      try {
        const leads = await dbHelpers.getLeads(user.id);
        results.leads = `Success: ${leads.length} leads found`;
        console.log('Leads data:', leads);
      } catch (error) {
        results.leads = `Error: ${error.message}`;
      }

      // Test 3: Test direct Supabase query
      console.log('Testing direct Supabase query...');
      try {
        const { data, error } = await supabase
          .from('leads')
          .select('*')
          .limit(5);
        
        if (error) {
          results.directQuery = `Error: ${error.message}`;
        } else {
          results.directQuery = `Success: ${data.length} leads found`;
        }
      } catch (error) {
        results.directQuery = `Exception: ${error.message}`;
      }

    } catch (error) {
      console.error('Test error:', error);
      results.general = `General Error: ${error.message}`;
    }

    setTestResults(results);
    setLoading(false);
  };

  return (
    <div className="card p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Dashboard Data Debug</h3>
      
      <button
        onClick={runTests}
        disabled={loading}
        className="btn-primary mb-4"
      >
        {loading ? 'Running Tests...' : 'Run Database Tests'}
      </button>

      <div className="space-y-2">
        {Object.entries(testResults).map(([test, result]) => (
          <div key={test} className="flex justify-between items-center p-2 bg-gray-50 rounded">
            <span className="font-medium capitalize">{test}:</span>
            <span className={`text-sm ${
              result.includes('Error') || result.includes('Exception') 
                ? 'text-red-600' 
                : 'text-green-600'
            }`}>
              {result}
            </span>
          </div>
        ))}
      </div>

      <div className="mt-4 p-3 bg-blue-50 rounded-lg">
        <h4 className="font-medium text-blue-900 mb-2">User Info:</h4>
        <p className="text-sm text-blue-700">User ID: {user?.id}</p>
        <p className="text-sm text-blue-700">Email: {user?.email}</p>
      </div>
    </div>
  );
};

export default DashboardDebug;
